import React, { Component } from "react";

export default class Upload extends Component{
  constructor(props) {
    super(props);

    this.state = {
      processing: false,
      progress: 0,
    };

    this.handleUpload = this.handleUpload.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  async handleUpload(e) {
    e.preventDefault();
    this.props.handleUpload(e.target.files);
    this.props.handleCancel();
  }

  handleCancel(e) {
    e.preventDefault();
    this.props.handleCancel();
  }

  render() {
    return (
      <tr id="choose" className={this.props.hide ? "" : "selected open"}>
        <td colSpan="2">
          <form>
            <input name="chooser" type="file" onChange={this.handleUpload} multiple/>
            <button className="btn" onClick={this.handleCancel}>Cancel</button>
          </form>
        </td>
      </tr>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Upload.js